// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"jitsi_bodywrapper__RTYpU","page-title":"jitsi_page-title__3I9k-","watermark":"jitsi_watermark__3Gdql"};